import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=b04e5c28&scoped=true&lang=pug&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04e5c28",
  null
  
)

export default component.exports